import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, switchMap, takeWhile } from 'rxjs/operators';
import { ApiConnectorService } from '../__api/api-connector.service';
import { FunctionsService } from '../__common/functions.service';
import { ResolverService } from '../__common/resolver.service';
import { ShopifyService } from '../__shopify/shopify.service';
import { HandleError, HttpErrorHandlerService } from '../http/http-error-handler.service';
import { interval, Observable, Subscription } from 'rxjs';
import { ConfigService } from '../___common/__config/config.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private readonly MAX_CHECKS = 12; // Adjust as needed
  private readonly INTERVAL_MS = 5000;

  private handlePostError: HandleError;

  constructor(private commonFunctions: FunctionsService,private resolver: ResolverService,private apiConnector: ApiConnectorService,private shopifyService: ShopifyService,private http: HttpClient,httpErrorHandler: HttpErrorHandlerService,private configService: ConfigService) {
    this.handlePostError = httpErrorHandler.createNewHandleError('OrdersService');
  }

  getClientInfo(){
    if(this.commonFunctions.getSelectedClientId()){
      // get session data info or clientDetails table data needed for the order
      return this.resolver.getDependency('userSession');
    }else{
      return null;
    }
  }

  generateOrderToken() {
    let token = this.commonFunctions.generateRandomNumber();
    this.commonFunctions.sewtCurrentToken(token);
    return token;
  }

  generateRandomNumber6Digit(){
    var val = Math.floor(100000 + Math.random() * 9000);
    return val;
  }

  buyProductOld(buyCta){
    // create an order object and set it to processing
    let orderObject = {};
    let clientDetails = this.getClientInfo();
      // if user is logged in I can get the info first

      let newShopifyOrder = {
        status: 'processing',
        FK_ID_clientDetails: this.resolver.getSelectedClientId()? this.resolver.getSelectedClientId(): -1,
        orderCode: this.generateOrderToken()
      };
      this.apiConnector.voyjaleasApiRequest('post','shopifyOrder',null,null,null,newShopifyOrder) /* this.commonFunctions.getSelectedClientId() */
      .subscribe(
          (response) => {
            if(response && response.OK){
              //this.checkIsOrderProcessed(response.OK.records.orderCode);
              orderObject['clientDetails;'] = clientDetails;
              orderObject['id'] =  response.OK.records.id;
              orderObject['cta'] = buyCta;
              this.shopifyService.buyProduct(orderObject['cta']);
            }else{
              this.resolver.saveOrderStatus(newShopifyOrder.orderCode,'unpaid');
            }
          },
          (error) => {
            console.log(error);
          }
      );
      // GO TO SHOPIFY AND CHECKOUT
    
  }

  buyThisProduct(){
    
  }

  generateOrderBody(){
    let newShopifyOrder = {
      status: 'processing',
      FK_ID_clientDetails: this.resolver.getSelectedClientId()? this.resolver.getSelectedClientId(): -1,
      orderCode: this.generateOrderToken()
    };
    return newShopifyOrder;
  }

  buyProduct(buyCta: any) {
    const newOrder = this.generateOrderBody();
    const apiURL = this.configService.getApiUrlRefactor('appBase')+'post/create.php?table=shopifyOrder';
    const httpOptions = this.commonFunctions.__HTTP_OPTIONS();
  
    return this.http.post<any>(apiURL, newOrder, httpOptions).pipe(
      map((response) => {
        // Optional: Check for API-specific success flags here
        return response;
      }),
      catchError(this.handlePostError('updatingNewElement', newOrder))
    );
  }

  checkIsOrderProcessed(orderId: string): Observable<any> {
    let counter = 0;

    return interval(this.INTERVAL_MS).pipe(
      takeWhile(() => counter < this.MAX_CHECKS),
      switchMap(() => {
        this.resolver.checkOrderStatus(orderId); // triggers backend refresh
        const status = this.resolver.getOrderStatus(orderId);
        const orderData = this.resolver.getCurrentOrderData(orderId);

        counter++;

        if (status === 'paid' || status === 'paymentPending') {
          return new Observable(observer => {
            observer.next({ status: 'paid', orderData });
            observer.complete();
          });
        }

        if (counter >= this.MAX_CHECKS) {
          this.resolver.saveOrderStatus(orderId, 'unpaid');
          return new Observable(observer => {
            observer.error('Timeout: Order not processed in time');
          });
        }

        return new Observable(observer => observer.next(null));
      }),
      takeWhile(result => result === null, true), // complete on result or error
      map(result => result) // pass result to subscriber
    );
  }
  


}
